import React from 'react';
import { MyContext } from "../../context";
import { useState, useContext } from "react";


function TicketCard(){

    const { LinkSelection, updateLinkSelection, updateInstallationLinkSelection, updateMyTicket } = useContext(MyContext);

    const view = async () => {
       // console.log("View")
        updateInstallationLinkSelection("Myticket")
        updateLinkSelection("Myticket")
        updateMyTicket("Ticket")
    }

    return (
       
        <>
          <div style={{display:'flex'}}>
<div class="col-md-6">
            <div class="card p-3 mb-2">
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-row align-items-center">
                        <div class="iconCard">   <span class="material-symbols-rounded">confirmation_number</span> </div>
                        <div class="ms-2 c-details">
                            <h6 class="mb-0">Ticket</h6> <span>Active Ticket</span>
                        </div>
                    </div>
                    <div class="badge"> <span>Z-Range</span> </div>
                </div>
                <div class="mt-3">
                    <p class="heading"><strong>Client Name</strong></p>
                    <div class="mt-3">
                        <hr />
                        <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">location_on</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}>Randburg</span>
  
  <span class="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>calendar_month</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Ticket Logged: </strong>14 June 2013</span>


  <span class="material-symbols-rounded writing" style={{paddingLeft:"20px", color:"#e1642d"}}>confirmation_number</span> 
  <span className='link' onClick={view}>
  {/**/} <span style={{marginTop: "-3px", paddingLeft:"2px"}}><strong>View </strong>Ticket</span></span>
  </div>
                     {/*    <div class="mt-3"> <span class="text1">32 Applied <span class="text2">of 50 capacity</span></span> </div>*/}
                    </div>
                </div>
            </div>
            </div>
            <div class="col-md-6">
            <div class="card p-3 mb-2">
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-row align-items-center">
                        <div class="iconCard"> 
                        <span class="material-symbols-rounded">Approval</span>
                         </div>
                        <div class="ms-2 c-details">
                            <h6 class="mb-0">Approval</h6> <span>Pending Ticket Approval</span>
                        </div>
                    </div>
                    <div class="badge"> <span>Pending</span> </div>
                </div>
                <div class="mt-3">
                    <p class="heading"><strong>Client Name</strong></p>
                    <hr />
                    <div class="mt-3">
                       
                    <div className='smallInfo' style={{display: "flex"}}>{/* <span class="material-symbols-rounded writing">location_on</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}>Randburg</span>*/}
  
  <span class="material-symbols-rounded writing">calendar_month</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Ticket Closed: </strong>13 June 2013</span>
  </div>

                    </div>
                </div>
            </div>
            </div>







            </div>
        </>
    )
}

export default TicketCard;






















